export const ApiParams = {
  page_type: 'page_type',
  page_slug: 'page_slug',
  page_id: 'page_id',
  form_slug: 'form_slug',
};
